import React from 'react';
import { useReveal } from '../lib/useReveal';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/j6YLFUuXnRWi5SPaEJqowo/ChatGPT_Image_22_jun_2026,_21_32_29.png';
const BADGES_TOP = [{
  icon: '📚',
  label: '6 Tomos Profesionales'
}, {
  icon: '🎁',
  label: '6 Bonos Exclusivos'
}, {
  icon: '📜',
  label: 'Certificado Digital'
}];
const BADGES_BOTTOM = [{
  icon: '⚡',
  label: 'Acceso Inmediato'
}, {
  icon: '📱',
  label: '100% Online'
}];
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="pt-10 pb-16 md:pt-16 md:pb-24 px-5 sm:px-6 overflow-hidden relative bg-[#FAFAF8]" data-id="element-189">
      {/* Soft glow behind mockup */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#D4AF37]/10 rounded-full blur-[100px] pointer-events-none" data-id="element-190"></div>

      <div ref={ref1} className={`reveal container mx-auto max-w-3xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-191">
        {/* Brand */}
        <p className="text-[#D4AF37] text-[11px] sm:text-xs font-bold tracking-[0.3em] uppercase mb-4" style={{
        fontFamily: "'Inter', sans-serif"
      }} data-id="element-192">
          🪷 Academia Holística Argentina
        </p>

        {/* Title */}
        <h1 className="text-[#1E2330] font-bold leading-[1.1] mb-4 text-4xl sm:text-5xl md:text-6xl" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-193">
          Aprendé Reiki desde Cero
        </h1>

        {/* Subtitle */}
        <p className="text-[#4A5568] text-base md:text-xl max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-194">
          La formación profesional para aprender Reiki, realizar sesiones y
          comenzar tu camino como terapeuta.
        </p>

        {/* Mockup */}
        <div className="block mx-auto w-full max-w-lg sm:max-w-xl mb-8 relative" data-id="element-195">
          <img src={HERO_IMG} alt="MegaPack Maestría Reiki" className="w-full max-h-[350px] sm:max-h-[450px] object-contain block mx-auto drop-shadow-[0_30px_60px_rgba(30,35,48,0.15)] relative z-10" data-id="element-196" />
        </div>

        {/* Rating */}
        <div className="flex items-center justify-center gap-2 mb-8" data-id="element-197">
          <div className="flex text-[#D4AF37] text-sm sm:text-base" data-id="element-198">
            ⭐⭐⭐⭐⭐
          </div>
          <span className="text-[#1E2330] text-sm sm:text-base font-bold" data-id="element-199">
            4.9/5
          </span>
          <span className="text-[#6B7280] text-sm sm:text-base font-medium" data-id="element-200">
            · +800 alumnos
          </span>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-4 w-full max-w-md mx-auto" data-id="element-201">
          <a href="#premium-offer" className="cta-btn w-full block px-6 py-5 rounded-2xl text-white font-extrabold text-lg sm:text-xl tracking-wide uppercase text-center bg-[#1E2330] shadow-[0_20px_40px_rgba(30,35,48,0.3)] hover:shadow-[0_25px_50px_rgba(30,35,48,0.4)] hover:-translate-y-1 transition-all" style={{
          fontFamily: "'Inter', sans-serif",
          letterSpacing: '0.05em'
        }} data-id="element-202">
            Quiero Comenzar Hoy
          </a>

          {/* Micro benefits */}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[#6B7280] text-xs sm:text-sm font-medium" data-id="element-203">
            <span className="flex items-center gap-1.5" data-id="element-204">
              <span className="text-[#D4AF37]" data-id="element-205">✔</span> Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-206">
              <span className="text-[#D4AF37]" data-id="element-207">✔</span> 100% Online
            </span>
            <span className="flex items-center gap-1.5" data-id="element-208">
              <span className="text-[#D4AF37]" data-id="element-209">✔</span> A tu ritmo
            </span>
          </div>
        </div>

        {/* Premium badges — 3 arriba, 2 abajo */}
        <div className="mt-10 space-y-3" data-id="element-210">
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-211">
            {BADGES_TOP.map((b, i) => <span key={i} className="inline-flex items-center gap-1.5 bg-white border border-[#EAE6E1] rounded-full px-3.5 py-2 text-[11px] sm:text-xs font-semibold text-[#1E2330] shadow-[0_4px_15px_rgba(0,0,0,0.03)] whitespace-nowrap" data-id="element-212">
                <span data-id="element-213">{b.icon}</span>
                {b.label}
              </span>)}
          </div>
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-214">
            {BADGES_BOTTOM.map((b, i) => <span key={i} className="inline-flex items-center gap-1.5 bg-white border border-[#EAE6E1] rounded-full px-3.5 py-2 text-[11px] sm:text-xs font-semibold text-[#1E2330] shadow-[0_4px_15px_rgba(0,0,0,0.03)] whitespace-nowrap" data-id="element-215">
                <span data-id="element-216">{b.icon}</span>
                {b.label}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}